export const API_ITEM_MASTER = {
    GET_ITEM_MASTER_DROPDOWN: '/api/v1/ProductHeaderItemMaster/GetProductHeaderItemMasterDropDown',
    CREATE_ITEM_MASTER: '/api/v1/ProductHeaderItemMaster/CreateProductInItemMaster',
    GET_ITEM_MASTER_DETAILS: '/api/v1/ProductHeaderItemMaster/GetProductDetailsItemMasterListByHeaderId',
    GET_SUB_CATEGORY_BY_CATEGORY_ID: '/api/v1/Category/GetSubCategoryByCategoryId',
    GET_ITEM_MASTER_LIST: '/api/v1/ProductHeaderItemMaster/GetProductHeaderItemMasterList'
};